export {default} from './ReportRecordDataProvider.connect';
